import { Component, Input, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { AumicoAppLayoutService } from '@modeso/aumico-layout/services/aumico-app-layout.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import Debug from 'debug';
import { onMainContentChange } from './../../animations/animations';

const debug = Debug('aumico:aumico-layout:AumicoAppLayout');

@UntilDestroy()
@Component({
    selector: 'app-aumico-layout',
    templateUrl: './app-layout.component.html',
    styleUrls: ['./app-layout.component.scss'],
    animations: [onMainContentChange],
})
export class AumicoAppLayout implements OnInit, OnDestroy {
    //@ViewChild('footerTemplate') footerTemplate!: TemplateRef<any>;

    footerOutlet: TemplateRef<any>;

    @Input() hideFooter = false;

    constructor(private service: AumicoAppLayoutService) {}
    ngOnInit() {
        this.service.onChangeFooterEvent$.pipe(untilDestroyed(this)).subscribe((tempalteRef: TemplateRef<any>) => {
            // Only hide footer when explicitly null, not undefined (which might be uninitialized)
            if (tempalteRef === null) {
                debug('Footer template is null, clearing footer outlet');
                this.footerOutlet = undefined;
                this.hideFooter = true;
                return;
            }
            // If we have a valid template reference, show the footer
            if (tempalteRef) {
                debug('Footer changed', tempalteRef);
                this.footerOutlet = tempalteRef;
                this.hideFooter = false;
            }
            // If undefined, do nothing - keep current state
        });
    }

    ngOnDestroy() {}
}
